var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefundCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9175 15.8432L15.8323 2.23662C14.0093 1.16209 11.6603 1.7689 10.5858 3.59196L2.61767 17.1108C1.54314 18.9339 2.14995 21.2828 3.97302 22.3574L27.0582 35.9639C28.8812 37.0384 31.2302 36.4316 32.3047 34.6086L40.2728 21.0897C41.3473 19.2666 40.7405 16.9177 38.9175 15.8432Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.737 21.9997L10.0499 4.50195L7.61476 8.63351L37.3018 26.1313L39.737 21.9997Z",
    fill: "#D1D5DB",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3905 15.5068L10.6149 16.2285",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2715 17.7949L14.4959 18.5166",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1594 20.0859L18.3839 20.8076",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0404 22.373L22.2648 23.0947",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66418 18.4355L13.8937 22.1073",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7117 30.8392C27.7636 31.4592 29.1189 31.1091 29.739 30.0571C30.359 29.0052 30.0088 27.6499 28.9569 27.0299C27.905 26.4098 26.5496 26.76 25.9296 27.8119C25.3096 28.8638 25.6597 30.2192 26.7117 30.8392Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefundCard);
export default __webpack_public_path__ + "static/media/icon_refund_card.e1cfc10b6928de09e2fa862bc1372d84.svg";
export { ForwardRef as ReactComponent };